import { useState, useEffect } from "react";
import { SubStandard } from "../../../manager/components/standards/common/types";
import { ProgressLocalStorageInterface } from "../ReportTypes";
import { ProgressStandardRow } from "./ProgressStandardRow";

export const ProgressSelectStandard = (props: {
  pathId: string;
  stateData: ProgressLocalStorageInterface;
  setStateData: React.Dispatch<
    React.SetStateAction<ProgressLocalStorageInterface | null>
  >;
  standard: SubStandard;
  depth: number;
  path: string;
}) => {
  const { pathId, stateData, setStateData, standard, depth } = props;

  const [isActive, setActive] = useState(false);
  const [expanded, setExpanded] = useState(false);
  let { path } = props;
  path = path.concat(`${depth === 1 ? "" : ".data."}`, pathId);

  // Controls which standard has been selected
  useEffect(() => {
    if (stateData.activatedPath === path) {
      setActive(true);
    } else {
      setActive(false);
    }

    if (stateData.activatedPath?.indexOf(path) !== -1) {
      setExpanded(true);
    }
  }, [stateData.activatedPath]);

  /**
   * Invoked when a standard is selected from the list of standards, updating the activated path
   * and setting the selected standard.
   * @param standard The standard which is selected
   * @param localPath The path to the standard
   */
  const selectStandard = (standard: SubStandard, localPath: string) => {
    if (stateData && standard.module_data) {
      if (stateData.activatedPath === localPath) {
        setStateData({
          ...stateData,
          activatedPath: "",
          skillcodes: [],
        });
      } else {
        setStateData({
          ...stateData,
          activatedPath: localPath,
          skillcodes: standard.module_data,
        });
      }
    }
  };

  return (
    <>
      <div>
        <div className="flow-root px-4">
          <ProgressStandardRow
            id={path}
            depth={depth}
            standard={standard}
            path={path}
            isActive={isActive}
            expanded={expanded}
            onClick={() => {
              setExpanded((prev: boolean) => !prev);
              selectStandard(standard, path);
            }}
          />
        </div>
      </div>

      {expanded &&
        standard.data &&
        Object.entries(standard.data).map(([k, v]) => (
          <ProgressSelectStandard
            key={k}
            pathId={k}
            stateData={stateData}
            setStateData={setStateData}
            standard={v}
            depth={depth + 1}
            path={path}
          />
        ))}
    </>
  );
};

export default ProgressSelectStandard;
